module.exports = __webpack_public_path__ + "img/spetsial'nyj-instrument.b434aa4b.svg";